module.exports = __webpack_public_path__ + "static/img/x-level-2.e825e5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user/x-level-2.svg
// module id = HDLi
// module chunks = 66